var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"error"}},[(_vm.value)?_c('ul',{staticClass:"input-error"},_vm._l((_vm.formattedErrors),function(error,i){return _c('li',{key:i,staticClass:"input-error__item"},[_vm._v(" * "+_vm._s(error)+" ")])}),0):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }